// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ELQ4","inner":"Footer_inner__kv6WU"};